import React from 'react';

export default function Footer() {
  return (
    <footer className="mx-auto max-w-[1200px] px-[clamp(20px,5vw,72px)] py-6 text-center">
      <p className="m-0 text-[13px] text-[#FBF0DC]/70">© {new Date().getFullYear()} Liuwei Luo</p>
    </footer>
  );
}
